export const attachAuthHeader = (getState, req) => {
  const {
    auth: {
      login: {
        authData: { AccessToken, AppUserGUID },
      },
    },
  } = getState();

  req.headers["Content-Type"] = "application/json";

  const hasAuthorizationHeader = req.url.endsWith("auth/refresh");

  if (AccessToken && !hasAuthorizationHeader) {
    const token = btoa(`${AppUserGUID}:${AccessToken}`);
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
};
